<div
  [ngClass]="{
    flex: prefix != null || suffix != null,
    'w--100': prefix != null || suffix != null
  }"
>
  <div *ngIf="prefix != null" class="prefix">{{ prefix }}</div>

  <!--
    Using ngSwitch instead of dynamically manipulating attr.type
    becaue of this long-standing issue:
    https://github.com/angular/angular/issues/13243
   -->
  <ng-container [ngSwitch]="type">
    <!-- text input -->
    <input
      *ngSwitchCase="'text'"
      [(ngModel)]="value"
      (focusin)="handleFocusIn($event)"
      (focusout)="handleFocusOut()"
      [selectionStart]="selectionStart"
      [selectionEnd]="selectionEnd"
      [scrollLeft]="scrollLeft"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [spellcheck]="spellcheck"
      type="text"
      [ngClass]="{
        'br--top-left': prefix == null,
        'br--bottom-left': prefix == null,
        'br--top-right': suffix == null,
        'br--bottom-right': suffix == null,
        'background--default': disabled
      }"
      [ngStyle]="{
        'width': width != null ? width.toString() + 'px' : null,
        'transition': 'width ' + expansionTime,
        'max-width': expandToFitValue ? maxWidth : null
      }"
    />

    <!-- number input -->
    <!-- NOTE: selectionStart and selectionEnd not supported for number input in HTML spec -->
    <input
      [max]="max"
      [min]="min"
      *ngSwitchCase="'number'"
      [(ngModel)]="value"
      (focusin)="handleFocusIn($event)"
      (focusout)="handleFocusOut()"
      [placeholder]="placeholder"
      [disabled]="disabled"
      type="number"
      [ngClass]="{
        'br--top-left': prefix == null,
        'br--bottom-left': prefix == null,
        'br--top-right': suffix == null,
        'br--bottom-right': suffix == null,
        'background--default': disabled
      }"
    />

    <!-- password input -->
    <input
      *ngSwitchCase="'password'"
      [(ngModel)]="value"
      (focusin)="handleFocusIn($event)"
      (focusout)="handleFocusOut()"
      [selectionStart]="selectionStart"
      [selectionEnd]="selectionEnd"
      [scrollLeft]="scrollLeft"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [spellcheck]="spellcheck"
      type="password"
      [ngClass]="{
        'br--top-left': prefix == null,
        'br--bottom-left': prefix == null,
        'br--top-right': suffix == null,
        'br--bottom-right': suffix == null,
        'background--default': disabled
      }"
    />

    <!-- email input -->
    <input
      *ngSwitchCase="'email'"
      [(ngModel)]="value"
      (focusin)="handleFocusIn($event)"
      (focusout)="handleFocusOut()"
      [selectionStart]="selectionStart"
      [selectionEnd]="selectionEnd"
      [scrollLeft]="scrollLeft"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [spellcheck]="spellcheck"
      type="email"
      [ngClass]="{
        'br--top-left': prefix == null,
        'br--bottom-left': prefix == null,
        'br--top-right': suffix == null,
        'br--bottom-right': suffix == null,
        'background--default': disabled
      }"
    />
  </ng-container>

  <div *ngIf="suffix != null" class="suffix">{{ suffix }}</div>
</div>

<!--Invisible span for measuring width-->
<span #ruler style="visibility: hidden; display: none"></span>
